import { request } from 'api/request';
import { POST, PRODUCT_RESEARCH_API_URLS } from 'api/constants';

export default class Orders {
  static getOrders(search) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.orders.orders,
      search,
    });
  }

  static downloadOrdersReport() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.orders.downloadOrdersReport,
      method: POST,
    });
  }
}
